import {DOM} from "../helpers/DOM.js";

export class DonationsForm{
	#otherAmountToggle;
	#otherAmountField;

	#variationsWrapper;

	constructor() {
		this.#otherAmountToggle = document.getElementById('other_amount_toggle');
		this.#otherAmountField = document.querySelector('.levcharity_form__donation_amount.custom_amount');

		this.#variationsWrapper = document.querySelector('.donation_variations');
		this.watchDonationVariationsForm();
	}
	watchOtherAmountToggle(){
		if(this.#otherAmountToggle){
			this.#otherAmountToggle.addEventListener('change', event => {
				this.#otherAmountField.style.display = this.#otherAmountToggle.checked ? '' : 'none';
			})
		}
	}

	watchVariationsChange() {
		if (this.#variationsWrapper) {
			DOM.addEvent('input,focus', 'input[type="number"]', (event, target) => {
				DOM.els('input[type="radio"]', this.#variationsWrapper)
					.forEach(radio => {
						radio.checked = false;
					});


				const checkbox = DOM.el('input[type="checkbox"]', target.closest('.variation_other_amount_wrapper'));

				if (checkbox){
					checkbox.checked = true;
				}

			}, this.#variationsWrapper, true);
			DOM.addEvent('change', 'input[type="radio"]', (event, target) => {

				DOM.els('input[type="number"]', this.#variationsWrapper)
					.forEach(input => {
						input.required = false;
						const checkbox = DOM.el('input[type="checkbox"]', input.closest('.variation_other_amount_wrapper'));

						if (checkbox){
							checkbox.checked = false;
						}
					});
			}, this.#variationsWrapper);


			DOM.addEvent('input', '.variation_quantity input[type="number"]', (event, target) => {

				const parentContainer = target.closest('.form-field.variation_checkbox_form_field');
				if (parentContainer) {
					const checkbox = parentContainer.querySelector('input[type="radio"].donation_variation_checkbox') ? parentContainer.querySelector('input[type="radio"].donation_variation_checkbox') : parentContainer.querySelector('input[type="checkbox"].donation_variation_checkbox');
					if (checkbox) {
						if (target.value > 0) {
							checkbox.checked = true;
						}else {
							checkbox.checked = false;
						}
					}
				}
			}, this.#variationsWrapper);

			DOM.addEvent('focusin', 'input[type="number"]', (event) => {
				const allInputs = document.querySelectorAll('.variation_quantity input[type="number"]');
				if(allInputs) {
					allInputs.forEach((input) => {
						const parentContainer = input.closest('.form-field.variation_checkbox_form_field');
						if (parentContainer) {
							const checkbox = parentContainer.querySelector('input[type="radio"].donation_variation_checkbox');
							if (checkbox) {
								checkbox.checked = parseFloat(input.value) > 0;
							}
						}
					});
				}
			}, this.#variationsWrapper);

		}
	}

	watchDonationVariationsForm() {

		const variationsForm = document.querySelector('.donation-variations-form');

		if (!variationsForm) {
			return;
		}


		DOM.addEvent('click', '.variation_other_amount_wrapper', (event, element) => {
			DOM.els('.donation_variation_checkbox')
				.forEach((e) => e.checked = false);
			element.querySelector('input').checked = true;
		})

		DOM.addEvent('click', '.variations_quantity_wrapper .add', (event, btn) => {
			const qtyInput = DOM.el('input', btn.closest('.variation_quantity'));
			const qtyElement = DOM.el('.value', btn.closest('.variations_quantity_wrapper'));
			const checkbox = DOM.el('input[class="donation_variation_checkbox"]', btn.closest('.variation_checkbox_form_field'));
			if (qtyInput) {
				event.preventDefault();
				qtyInput.value = +qtyInput.value + 1;
				qtyElement.textContent = qtyInput.value;

				if (qtyInput.value > 0 && checkbox) {
					checkbox.checked = true;
				}
			}
		});

		DOM.addEvent('click', '.variations_quantity_wrapper .remove', (event, btn) => {
			const qtyInput = DOM.el('input', btn.closest('.variation_quantity'));
			const qtyElement = DOM.el('.value', btn.closest('.variations_quantity_wrapper'));
			const checkbox = DOM.el('input[class="donation_variation_checkbox"]', btn.closest('.variation_checkbox_form_field'));


			if (qtyInput && qtyInput.value > 0) {
				event.preventDefault();
				qtyInput.value = +qtyInput.value - 1;
				qtyElement.textContent = qtyInput.value;

				if (qtyInput.value == 0 && checkbox) {
					checkbox.checked = false;
				}
			}
		});

		DOM.addEvent('change', '.donation_variation_checkbox', () => {
			const otherCheckbox = DOM.el('.variation_other_amount_wrapper input');
			if (otherCheckbox) {
				otherCheckbox.checked = false;
				DOM.el('.variation_other_amount_wrapper input[type="number"]').value = '';
			}
		});

		DOM.addEvent('input', 'input[class="without-price"]', (event, input) => {
			const parentWrapper = input.closest('.variation_checkbox_form_field');
			const checkbox = parentWrapper?.querySelector('input.donation_variation_checkbox');
			if (input.value > 0 && checkbox) {
				checkbox.checked = true;
			} else if (checkbox) {
				checkbox.checked = false;
			}
		});

	}

}
